import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "study_list",
    list_id: "section_study_list",
    x_column_list_arr: [
      { "key": "check_box", "name": "Check", "width": "40", "is_show": "1" },
      { "key": "row_view_num", "name": "No.", "width": "50", "is_show": "1" },
      { "key": "a_title", "name": "소단원명", "width": "180", "is_show": "1" },
      // {"key":"a_goal","name":"학습목표","width":"140","is_show":"1"},
      // { "key": "a_content", "name": "내용", "width": "100", "is_show": "1" },
      { "key": "a_amount_num", "name": "수량", "width": "50", "is_show": "1" },
      { "key": "a_amount_sort", "name": "구분", "width": "70", "is_show": "1" },
      { "key": "a_page_start_num", "name": "시작page", "width": "90", "is_show": "" },
      { "key": "a_par_id", "name": "부모ID", "width": "90", "is_show": "" },
      { "key": "a_par_seq", "name": "부모키", "width": "90", "is_show": "" },
      { "key": "a_add_file_type", "name": "첨부", "width": "70", "is_show": "" },
      { "key": "a_section_seq", "name": "대단원", "width": "100", "is_show": "1" },
      { "key": "row_view_manage", "name": "관리", "width": "210", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 10,
      'order_id': 'a_title',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
      "is_add_idx_info": "1",
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["a_title_seq", "a_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.select_arr["a_add_file_type"] = [
    { "value": "image", "text": "사진" },
    { "value": "audio", "text": "음성" },
    { "value": "video", "text": "동영상" },
  ];

  return xColumnArr;
};

export default getXcolumnJson;